import React from 'react';
import { CompanyTable } from './components';

const Companies = () => {
  return <CompanyTable />;
};

export default Companies;
